<template>
  <div class="card card-content card--interactive text-center w-1/6">
    <div class="flex-item">
      <h4
        class="text-blue uppercase -mt-2 mb-4"
        v-text="title"
      />
      <h2
        class="mb-4"
        v-text="count"
      />
    </div>
  </div>
</template>

<script type="text/babel">
export default {
  name: 'EmailDeliveryStatCard',
  props: {
    title: {
      type: String,
      required: true,
    },
    count: {
      type: Number,
      required: false,
      default: 0,
    },
  },
}
</script>
